/**
 * RESPONSIBILITY: the giving band on the home page.
 *
 * The appeal's picture is HANDED to it, because that photograph belongs to the appeal and
 * not to this band — see the House of Honor section. The band may still carry one of its
 * own, and does when somebody fills that field in. The words are the band's own either
 * way: a teaser says something shorter than the page it points at.
 */
import { Html } from '@framework/react';
import type { ImageValue } from '@framework/core';
import type { HomeGiveSection } from '@app/sections';
import { Picture } from '../commons/Picture';

export function HomeGive({ c, image }: { c: HomeGiveSection; image: ImageValue | undefined }) {
  // The page cream, not the tint: it sits below the grey ministries band, and alternating
  // is what lets each read as its own section.
  return (
    <section className="band">
      <div className="wrap split split-reverse">
        <div className="stack">
          {c.eyebrow && <p className="eyebrow">{c.eyebrow}</p>}
          <h2>{c.heading}</h2>
          {c.bodyHtml && <Html className="md-body lede">{c.bodyHtml}</Html>}
          {c.ctaLabel && <a className="btn btn-gold" href={c.ctaHref || '#'}>{c.ctaLabel}</a>}
        </div>
        <Picture value={c.image?.path ? c.image : image} alt="" className="block-pic" />
      </div>
    </section>
  );
}
